import { render, staticRenderFns } from "./vieworganization.vue?vue&type=template&id=2fec35da&scoped=true"
import script from "./vieworganization.vue?vue&type=script&lang=js"
export * from "./vieworganization.vue?vue&type=script&lang=js"
import style0 from "./vieworganization.vue?vue&type=style&index=0&id=2fec35da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec35da",
  null
  
)

export default component.exports